import React from "react";

/**
 * Material Symbols Outlined icon.
 * Font is loaded in public/index.html.
 */
const Icon = ({ name, className = "", fill = false, style, ...rest }) => (
  <span
    className={`material-symbols-outlined ${className}`}
    style={{ fontVariationSettings: fill ? "'FILL' 1" : "'FILL' 0", ...style }}
    aria-hidden="true"
    {...rest}
  >
    {name}
  </span>
);

export default Icon;
